(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sc-frete-lateral"] && !Shopify.designMode) return;
  try {
    (() => {
    const root = document.getElementById('sc-frete-lateral');
    if (!root) return;

    const tab = root.querySelector('.sc-frete-lateral__aba');
    const panel = root.querySelector('.sc-frete-lateral__painel');
    const close = root.querySelector('.sc-frete-lateral__fechar');
    let opener = tab;

    const updateExpanded = (open) => {
      tab.setAttribute('aria-expanded', String(open));

      document.querySelectorAll('[data-sc-frete-open]').forEach((button) => {
        button.setAttribute('aria-expanded', String(open));
      });
    };

    const openPanel = (trigger) => {
      opener = trigger;

      if (!panel.open) panel.showModal();

      updateExpanded(true);
      close.focus();
    };

    tab.addEventListener('click', () => openPanel(tab));

    document.addEventListener('click', (event) => {
      const trigger = event.target.closest?.(
        '.sc-home-frete--card [data-sc-frete-open]'
      );

      if (!trigger) return;

      event.preventDefault();
      event.stopPropagation();
      openPanel(trigger);
    }, true);

    close.addEventListener('click', () => panel.close());

    panel.addEventListener('close', () => {
      updateExpanded(false);
      (opener.isConnected ? opener : tab).focus();
    });

    panel.addEventListener('click', (event) => {
      if (event.target !== panel) return;

      const bounds = panel.getBoundingClientRect();

      if (
        event.clientX < bounds.left ||
        event.clientX > bounds.right ||
        event.clientY < bounds.top ||
        event.clientY > bounds.bottom
      ) {
        panel.close();
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
